module.exports = __webpack_public_path__ + "img/image-026.b9de4114.png";